var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item.is_simulator
    ? _c(
        "div",
        { class: _vm.getClassName("simulator"), attrs: { id: "simulator" } },
        [
          _c("h2", { class: _vm.getClassName("simulator__title") }, [
            _vm._v("シミュレーションをしてみる")
          ]),
          _vm._v(" "),
          _c("p", { class: _vm.getClassName("simulator__comment") }, [
            _vm._v(
              "\n    生地と選んだパーツがシミュレーション画面に表示されます。\n    "
            ),
            _c("br", { staticClass: "sp" }),
            _vm._v("\n    色・柄の組み合わせのチェックにご活用ください。\n  ")
          ]),
          _vm._v(" "),
          _c(
            "p",
            { class: ["txtRed", _vm.getClassName("simulator__comment--red")] },
            [_vm._v("\n    こちらで選んだ商品はカートに反映されません\n  ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "simulator__wrapper" }, [
            _c("div", { class: _vm.getClassName("simulator__container") }, [
              _c("div", { class: _vm.getClassName("simulator__canvas") }, [
                _c("h3", { class: _vm.getClassName("simulator__summary") }, [
                  _vm._v("シミュレーション画面")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { class: _vm.getClassName("simulator__images") },
                  [
                    _vm.getMainImage
                      ? _c("v-img", {
                          class: [
                            "simulator__image--main",
                            _vm.getClassName("simulator__image")
                          ],
                          attrs: {
                            src: _vm.getMainImage,
                            contain: "",
                            width: _vm.media ? (200 / 280) * 100 + "%" : 380,
                            height: _vm.media ? undefined : 380,
                            "aspect-ratio": _vm.media ? 200 / 200 : 380 / 380
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.getSubImage
                      ? _c("v-img", {
                          class: [
                            "simulator__image--sub",
                            _vm.getClassName("simulator__image")
                          ],
                          attrs: {
                            src: _vm.getSubImage,
                            contain: "",
                            width: _vm.media ? (200 / 280) * 100 + "%" : 380,
                            height: _vm.media ? undefined : 380,
                            "aspect-ratio": _vm.media ? 200 / 200 : 380 / 380
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              !_vm.media
                ? _c(
                    "div",
                    { staticClass: "simulator__controll" },
                    [
                      _vm._l(this.item.parts_categories, function(category) {
                        return [
                          _vm.isSimulator(category.items)
                            ? [
                                _c(
                                  "h3",
                                  {
                                    key: "caption" + category.id,
                                    staticClass: "simulator__caption"
                                  },
                                  [
                                    _vm._v(
                                      "パーツ（" + _vm._s(category.name) + "）"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.item.is_simulator
                                  ? _c("SelectColors", {
                                      key: category.id,
                                      staticClass: "simulator__select",
                                      attrs: {
                                        items: category.items,
                                        media: _vm.media,
                                        simulation: ""
                                      },
                                      model: {
                                        value: _vm.sub,
                                        callback: function($$v) {
                                          _vm.sub = $$v
                                        },
                                        expression: "sub"
                                      }
                                    })
                                  : _vm._e()
                              ]
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                : _c(
                    "div",
                    { staticClass: "simulator__controll--sp" },
                    [
                      _c(
                        "ul",
                        { staticClass: "simulator__tabs" },
                        [
                          _vm._l(this.item.parts_categories, function(
                            category
                          ) {
                            return [
                              _vm.isSimulator(category.items)
                                ? _c(
                                    "li",
                                    {
                                      key: _vm.uuid + "-" + category.id,
                                      staticClass: "simulator__tab"
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          class: _vm.getTabClass(
                                            "category-" + category.id
                                          ),
                                          attrs: {
                                            for: _vm.uuid + "-" + category.id
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(category.name) +
                                              "\n                "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.controll,
                                                expression: "controll"
                                              },
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: false,
                                                expression: "false"
                                              }
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: _vm.uuid + "-" + category.id
                                            },
                                            domProps: {
                                              value: "category-" + category.id,
                                              checked: _vm._q(
                                                _vm.controll,
                                                "category-" + category.id
                                              )
                                            },
                                            on: {
                                              change: function($event) {
                                                _vm.controll =
                                                  "category-" + category.id
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._l(this.item.parts_categories, function(category) {
                        return [
                          _vm.item.is_simulator
                            ? _c("SelectColors", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      "category-" + category.id ===
                                      _vm.controll,
                                    expression:
                                      "`category-${category.id}` === controll"
                                  }
                                ],
                                key: category.id,
                                staticClass: "simulator__select--sp",
                                attrs: {
                                  items: category.items,
                                  media: _vm.media,
                                  simulation: ""
                                },
                                model: {
                                  value: _vm.sub,
                                  callback: function($$v) {
                                    _vm.sub = $$v
                                  },
                                  expression: "sub"
                                }
                              })
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }